export function escapeRegexp(queryToEscape:string):string {
  return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
}



// WEBPACK FOOTER //
// ./src/app/components/form/select/ng-select/common.ts